import { TourPage } from '@carboncopyco/components';
import { selectOrganizationId, useLazyGetTourQuery } from '@carboncopyco/data';
import { Button } from '@carboncopyco/ui';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ErrorPage from '../../components/ErrorPage';
import WorkspaceLayout from '../../components/Workspaces/WorkspaceLayout';
import { useCustomNavigate } from '../../hooks/useCustomNavigate';
import { useFlagsFallback } from '../../hooks/useFlagsFallback';

type TabId = 'activity' | 'links' | 'overview' | 'history';
type Params = {
  organizationId: string;
  tourId: string;
  workspaceId?: string;
  tabId?: TabId;
};

export const TourScreen = () => {
  const organizationId = useSelector(selectOrganizationId);
  const { toursShareAspectRatio } = useFlagsFallback();
  const { tourId, workspaceId } = useParams<Params>();
  const navigate = useNavigate();

  const {
    navigateToTourEditor,
    navigateToTourPreview,
    navigateToTourPageByWorkspace,
    navigateToWorkspace,
    navigateToFolder,
    links,
  } = useCustomNavigate();

  const [getTour, { data: tour, error: tourError }] = useLazyGetTourQuery();
  useEffect(() => {
    if (tourId && organizationId && workspaceId) {
      getTour({
        workspaceId,
        organizationId,
        id: Number(tourId),
      });
    }
  }, [tourId, organizationId, workspaceId]);

  if (!tourId || !workspaceId) return null;

  if (tourError) {
    return (
      <ErrorPage
        title="Error fetching tour"
        buttons={
          <Button
            label="Go to previous page"
            onClick={() => {
              navigate(-1);
            }}
          />
        }
      />
    );
  }

  return (
    <WorkspaceLayout>
      <TourPage
        readOnly={tour?.readOnly}
        rootPath={links.getTourPageRoot(Number(tourId))}
        tourId={Number(tourId)}
        goToCopiedTour={(tourId, workspaceId) =>
          navigateToTourPageByWorkspace(tourId, workspaceId, 'overview')
        }
        workspaceId={workspaceId}
        organizationId={organizationId}
        goToTourPreview={navigateToTourPreview}
        goToTour={({ id, workspaceId }) =>
          navigateToTourPageByWorkspace(id, workspaceId)
        }
        tourDemoPath={links.getDemoPageLink(
          Number(tour?.demoData?.[0]?.demoId)
        )}
        goBack={navigateToWorkspace}
        handleEdit={() => navigateToTourEditor({ id: tourId })}
        goToLinksTab={() =>
          navigateToTourPageByWorkspace(Number(tourId), workspaceId, 'links')
        }
        toursShareAspectRatioEnabled={toursShareAspectRatio}
        goToWorkspacePage={navigateToWorkspace}
        goToFolderPage={navigateToFolder}
      />
    </WorkspaceLayout>
  );
};
